<!-- Wrapper component for Carbon structured list
     Default styling for Carbon structured list has display: table, which requires
     a wrapper in order to set the overflow property -->
<template>
  <div class="structured-list-wrapper">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import "@styles/layout/z-map";

.structured-list-wrapper {
  max-height: calc((var(--vh, 1vh) * 75));
  max-width: 100%;
  overflow-x: auto;

  .content-subpage & {
    max-height: calc((var(--vh, 1vh) * 65));
    /*IOS Safari*/
    transform: translateZ(0);
    border-radius: 10px;
  }

  .bx--structured-list-thead {
    position: sticky;
    top: 0;
    z-index: calc(#{z-map("default")} + 1);
  }
}
</style>
